var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventoryNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 29.6875H31.25",
    stroke: "#EC2347",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 23.4375H31.25",
    stroke: "#EC2347",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2504 7.8125H39.0625C39.4769 7.8125 39.8743 7.97712 40.1674 8.27015C40.4604 8.56317 40.625 8.9606 40.625 9.375V42.1875C40.625 42.6019 40.4604 42.9993 40.1674 43.2924C39.8743 43.5854 39.4769 43.75 39.0625 43.75H10.9375C10.5231 43.75 10.1257 43.5854 9.83265 43.2924C9.53962 42.9993 9.375 42.6019 9.375 42.1875V9.375C9.375 8.9606 9.53962 8.56317 9.83265 8.27015C10.1257 7.97712 10.5231 7.8125 10.9375 7.8125H18.7496",
    stroke: "#EC2347",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 14.0625V12.5C17.1875 10.428 18.0106 8.44086 19.4757 6.97573C20.9409 5.5106 22.928 4.6875 25 4.6875C27.072 4.6875 29.0591 5.5106 30.5243 6.97573C31.9894 8.44086 32.8125 10.428 32.8125 12.5V14.0625H17.1875Z",
    stroke: "#EC2347",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryNew);
export default __webpack_public_path__ + "static/media/InventoryNew.a42b6279ea7d4ac52e6aeb8d8e2adee5.svg";
export { ForwardRef as ReactComponent };